module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_industrial-designs.556e35af.png";